export type AccessRole = "owner" | "manager" | "team_member" | "volunteer";
export type AccessPreset = "full_access" | "home_visits";

/**
 * Display name of a role in the access model (owner / manager / team member / volunteer). Only for showing a person's
 * role as words: screens decide what to show by permission (`useCan`), never by this name. Any other value reads as
 * Team member, the least.
 */
export const roleLabelKey = (role: AccessRole | string | null | undefined): string =>
  `access.role.${role === "owner" || role === "manager" || role === "volunteer" ? role : "team_member"}`;

/**
 * The role word every ordinary screen uses (owner note A5, 2026-10-25): the Owner and the Managers are both just "Manager" to the
 * people they work with. The precise words (`roleLabelKey`: Owner above Manager) belong on the team list, the roles and
 * permissions screens and the staff console only.
 */
export const roleWordKey = (role: AccessRole | string | null | undefined): string => roleLabelKey(role === "owner" ? "manager" : role);

/** Display name of a starting set. A named set made on the console carries its own name instead. */
export const presetLabelKey = (preset: AccessPreset): string => `access.preset.${preset}`;
